import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Breadcrumb } from '../progress/contract-progress.component';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-contract-progress-advice',
    templateUrl: './../progress/contract-progress.component.html',
    styleUrls: ['./../progress/contract-progress.component.scss'],
})
export class ContractProgressAdviceComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    public percent = 0;

    @Input()
    public breadcrumbs: Breadcrumb[] = [
        { title: 'progress.form', percent: 10 },
        { title: 'progress.participants', percent: 20 },
        { title: 'progress.select-sign', percent: 30 },
        { title: 'progress.test-suitability', percent: 50 },
        { title: 'progress.test-result', percent: 60 },
        { title: 'progress.exonerate-products', percent: 70 },
        { title: 'progress.full-data', percent: 80 },
        { title: 'progress.complete', percent: 100 },
    ];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
